import mediaQueries from '../constants/mediaQueries'

export function checkMediaQuery(mediaQuery, method = 'only') {
	if (!mediaQueries[mediaQuery]) {
		return true
	}

	let mediaQueryString

	switch (method) {
		case 'min': {
			const minBreakpoint = mediaQueries[mediaQuery].min

			if (!minBreakpoint) {
				return true
			}

			mediaQueryString = `(min-width: ${minBreakpoint}px)`

			break
		}
		case 'max': {
			const maxBreakpoint = mediaQueries[mediaQuery].max

			if (!maxBreakpoint) {
				return true
			}

			mediaQueryString = `(max-width: ${maxBreakpoint}px)`

			break
		}
		case 'only': {
			const minBreakpoint = mediaQueries[mediaQuery].min
			const maxBreakpoint = mediaQueries[mediaQuery].max

			mediaQueryString = `(min-width: ${minBreakpoint}px)`

			if (maxBreakpoint) {
				mediaQueryString += ` and (max-width: ${maxBreakpoint}px)`
			}

			break
		}
		default: {
			return true
		}
	}

	return window.matchMedia(mediaQueryString).matches
}
